export const EXPIRED_TOKEN_EXCEPTION = "ExpiredTokenException";
